// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-a546853a] textarea{min-height:108px!important;height:108px!important}", "",{"version":3,"sources":["webpack://./resources/js/components/forms/ContactForm.vue"],"names":[],"mappings":"AACA,2BACI,0BAAA,CACA,sBAAJ","sourcesContent":["\n::v-deep textarea {\n    min-height: 108px !important;\n    height: 108px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
